import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7c57175b"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "total-row-content align-left"
}, " Total ", -1));
const _hoisted_2 = {
  key: 0,
  style: {
    marginRight: '10px'
  }
};
const _hoisted_3 = {
  key: 1,
  class: "total-row-content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_skeleton_item = _resolveComponent("skeleton-item");
  const _component_b_td = _resolveComponent("b-td");
  const _component_TableBarElement = _resolveComponent("TableBarElement");
  const _component_b_tr = _resolveComponent("b-tr");
  const _component_b_tbody = _resolveComponent("b-tbody");
  const _component_b_table_simple = _resolveComponent("b-table-simple");
  return $props.totalLoading ? (_openBlock(), _createBlock(_component_skeleton_item, {
    key: 0
  })) : (_openBlock(), _createBlock(_component_b_table_simple, {
    key: 1,
    fluid: "",
    id: "totalTable",
    class: "total-table"
  }, {
    default: _withCtx(() => [_createVNode(_component_b_tbody, null, {
      default: _withCtx(() => [_createVNode(_component_b_tr, {
        class: "total-row"
      }, {
        default: _withCtx(() => [_createVNode(_component_b_td, {
          style: _normalizeStyle($options.getStyle(this.getTotalColWidths[0]))
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }, 8, ["style"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.graphHeaders.slice(1), (header, index) => {
          return _openBlock(), _createBlock(_component_b_td, {
            key: index,
            style: _normalizeStyle($options.getStyle(this.getTotalColWidths[index + 1])),
            class: _normalizeClass(header.isString ? 'align-left' : 'align-right'),
            title: header.name
          }, {
            default: _withCtx(() => [$props.showTotalItem ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_skeleton_item)])) : (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_TableBarElement, {
              amount: $options.getTotal(header.key, index),
              alignCenter: true,
              noBar: true,
              isString: header?.key === 'keyword_bid' ? true : header.isString ?? false,
              truncateLength: header?.truncateLength || 15,
              color: '#FFF',
              precision: header?.precision || 0,
              isCurrency: header?.isCurrency || false,
              isPercentage: header?.isPercentage || false,
              isEvolution: header?.isEvolution || false,
              isCaseColor: header?.isCaseColor || false,
              isDecimal: header?.isDecimal || false,
              digitSeparator: header?.digitSeparator,
              showCurrencySign: header?.showCurrencySign,
              decimalThreshold: header?.decimalThreshold || 0,
              isBoolCase: header?.isBoolCase || false,
              showTitle: false
            }, null, 8, ["amount", "isString", "truncateLength", "precision", "isCurrency", "isPercentage", "isEvolution", "isCaseColor", "isDecimal", "digitSeparator", "showCurrencySign", "decimalThreshold", "isBoolCase"])]))]),
            _: 2
          }, 1032, ["style", "class", "title"]);
        }), 128))]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }));
}